export const SUBTYPE_CONTENUTO = {
  LINK_ESTERNO: 1,
  PAGINA_INFORMATIVA: 2,
  LINK_A_MEDIA_FILE: 3,
};
